// Canales como add-ons (ronda 4, decisión de Marcos 2026-10-08): en Ajustes → Bandejas → Nueva solo WhatsApp viene
// activo. ChannelItem.vue (upstream) deja activas SMS / API / Telegram / LINE sin flag nativo; con esto las decide la clave
// de módulo del owner (feature_channel_*, Masifi::Settings, entregada en enabled_features). Touchpoint: import + 1 línea
// (`if (key in masifiChannel) return masifiChannel[key](props.enabledFeatures);`). El backend
// (Masifi::ChannelEntitlements) rechaza igual el alta si la clave no está.
export const MASIFI_CHANNEL_FEATURES = Object.freeze({
  sms: 'feature_channel_sms',
  api: 'feature_channel_api',
  telegram: 'feature_channel_telegram',
  line: 'feature_channel_line',
});

// { canal: features => activa? } sin prototipo: `key in masifiChannel` solo es true para los 4 canales.
const masifiChannel = Object.freeze(
  Object.assign(
    Object.create(null),
    Object.fromEntries(
      Object.entries(MASIFI_CHANNEL_FEATURES).map(([key, feature]) => [
        key,
        features => Boolean(features?.[feature]),
      ])
    )
  )
);

export default masifiChannel;
